export function isBillable(entry, categories) {
    if (!entry.msdyn_transactioncategoryid)
        return false;
    const c = categories.find((x) => x.msdyn_transactioncategoryid === entry.msdyn_transactioncategoryid);
    return c?.msdyn_billingtype === "Chargeable";
}
export function billableLabel(billable) {
    return billable ? "Billable" : "Non-billable";
}
